var _image, _image2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGear = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    y: 1,
    width: 20,
    height: 18,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAABVElEQVQ4jaWUP27CMBjFX9oeACVLRiTLs+kNuAH0BMAJEFPHwgkqxk7Qja3pDbhByVYpimBlabN2q770BTkOgVDelOizf/7+2M+DI6VNC8AzgDYjkzSJN/iLdRgT7RjLbEIJSNgHAAHMAQjgCcCISxYAZoyPGb+3oXdOgrIgS5P4gf9rpU3GzUW2Sysmh3cBRHXAighYnlhSKvnGCW6YZVN1uKcW2Gezm2rHPQflJSttpgB6nOzoAuBEBqW0kR6/p0k89ZQ2QzZ9liZx1ABSkdKmz9swv/WDUO7VS5rEq//ARN9f+08/CH8ADNweXi3JUC732A/CvZx0RcmPUqmHI0Np2kuCFpx2PhR3wVBps70gsy2HepDbw8gyhSZq288OR4CVm39GlZd19i2zpAF/Xy1zKCQOVQuUE1tKm7c6+6LFFfYl32sbcMpgcyurMdgCWjZYAL9wUHWoOHDwhQAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 7,
    y: 7,
    width: 6,
    height: 6,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAjElEQVQImS2MMQ7CMBAEb+2ALAWJIw1tFEIb8hyegV8QUVHyBZ5DR+TasskLgA4JwiEjtpltZkBEVNVNB2CXvoicgncWVd0cAfD4giVDrEfpROSK1Xpz+7xVG+NlSEZZtqwzieqvPxJ/M09O0ItiaQDaMhc98wwa+UFIzip4tyfIXWXTXk/mMfWDd/YLKAczMSSEOaAAAAAASUVORK5CYII="
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGear);
export default ForwardRef;